import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../components/HomePage';
import MenuPage from '../components/MenuPage';
import AboutPage from '../components/AboutPage';
import ServicesPage from '../components/ServicesPage';
import BlogPage from '../components/BlogPage';
import BlogDetails from '../components/BlogDetails';
import ContactPage from '../components/ContactPage';
import NotFoundPage from '../components/NotFoundPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/menu" element={<MenuPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/details" element={<BlogDetails />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
